module.exports = ".custom-day {\n  text-align: center;\n  padding: 0.185rem 0.25rem;\n  display: inline-block;\n  height: 2rem;\n  width: 2rem;\n}\n\n.custom-day.focused {\n  background-color: #e6e6e6;\n}\n\n.custom-day.range,\n.custom-day:hover {\n  background-color: rgb(2, 117, 216);\n  color: white;\n}\n\n.custom-day.faded {\n  background-color: rgba(2, 117, 216, 0.5);\n}\n\n.mb-2 {\n  margin: 15px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/anagrafica/selezione-periodo/periodo.css
// module id = ./src/app/anagrafica/selezione-periodo/periodo.css
// module chunks = main